// Defensive duration extractor over products.legs jsonb. Legacy computes
// hours from `legs[0].details.startTime/endTime` (clock-shaped {hours,
// minutes}). For the list cell we only need an integer-hour estimate — if
// the shape doesn't match (rentals, accommodations, missing legs), return
// null and the renderer shows "—".

type ClockTime = { hours: number; minutes: number };

const isClockTime = (v: unknown): v is ClockTime =>
  typeof v === 'object' &&
  v !== null &&
  typeof (v as { hours?: unknown }).hours === 'number' &&
  typeof (v as { minutes?: unknown }).minutes === 'number';

const toMinutes = (t: ClockTime): number => t.hours * 60 + t.minutes;

export const extractDurationHours = (legs: unknown): number | null => {
  if (!Array.isArray(legs) || legs.length === 0) return null;
  const first = legs[0] as { details?: unknown } | null;
  if (!first || typeof first !== 'object') return null;
  const details = (first as { details?: unknown }).details;
  if (!details || typeof details !== 'object') return null;
  const start = (details as { startTime?: unknown }).startTime;
  const end = (details as { endTime?: unknown }).endTime;
  if (!isClockTime(start) || !isClockTime(end)) return null;
  const diff = Math.abs(toMinutes(end) - toMinutes(start));
  if (diff === 0) return null;
  return Math.round(diff / 60);
};
